import { use } from 'react'

import { ConsoleLayoutContext } from '../context'

export const useConsoleLayout = () => {
  return use(ConsoleLayoutContext)
}
